// 单国实例配置:科特迪瓦(CIV)。
// 后端 mst_currency 仅 open 1 国(见 sql/migrations/M20),前端据此锁死单国 ——
// router/index.js 用它强制 country=CIV、跳过 /Country 选国家弹窗;
// TopNav.vue 等多国 UI 用它隐藏国家切换器入口。
// 多国扩展:把 SINGLE_COUNTRY 改为 null,所有引用处自动回到多国选择流程。
export const SINGLE_COUNTRY = {
  country: 'CIV',
  currency: 'XOF',
  platform: 'Otbet',
  areaCode: '+225',
  currencyUnit: 'CFA', // 面向玩家的金额展示符(非 ISO 码);ISO 码见上方 currency:'XOF'
  countryName: "Cote d'Ivoire",
  defaultLanguage: 'en' // 默认英语;用户可在「我的→设置」切换并保持(见 router applySingleCountry 的 langUserSet 例外)
}
